// schema/nodes/paragraph.ts
import { DesignSystem } from "@adornis/chemistry/elements/theming/design.js";
var getAttrs = (node) => {
  const style = node.getAttribute("style") || "";
  const textAlignMatch = /text-align:\s*(\w+)/.exec(style);
  return {
    slot: node.getAttribute("slot"),
    textAlign: textAlignMatch ? textAlignMatch[1] : "left"
  };
};
var PARAGRAPH_SCHEMA = () => ({
  content: "inline*",
  group: "block",
  draggable: false,
  parseDOM: [
    {
      tag: "p",
      getAttrs
    },
    {
      tag: "x-text",
      getAttrs
    },
    {
      tag: `${DesignSystem.prefix}-text`,
      getAttrs
    }
  ],
  attrs: {
    slot: { default: null },
    textAlign: { default: "left" }
  },
  toDOM: (node) => {
    return [
      `${DesignSystem.prefix}-text`,
      {
        slot: node.attrs.slot,
        style: node.attrs.textAlign ? `text-align: ${node.attrs.textAlign}; margin-block-start: 1em; margin-block-end: 1em` : void 0
      },
      0
    ];
  }
});
var PARAGRAPH_KEY = "paragraph";
var PARAGRAPH = {
  [PARAGRAPH_KEY]: PARAGRAPH_SCHEMA
};
export {
  PARAGRAPH,
  PARAGRAPH_KEY,
  PARAGRAPH_SCHEMA
};
